export const routeNames = {
  splash: "/",
  home: "Home",
};
